import React, { Component } from 'react';
import Dictionary from '../../../model/Dictionary';
import './SeatsInfo.css';
import ClassNames from 'classnames';
import { Collapse } from 'material-ui';
import ChevronDownIcon from '../../../icons/ChevronDownIcon';
import ChevronUpIcon from '../../../icons/ChevronUpIcon';

export default class Seats extends Component {
  state = { more: false };

  toggleMore = () => {
    this.setState({ more: !this.state.more });
  };

  render () {
    const { more } = this.state;
    return (
      <div className='seats-info'>
        <div className='seats-header' onClick={this.toggleMore}>
          <a className={ClassNames({ active: more })}>{Dictionary.seats.info.title}</a>
          <span>{more ? <ChevronUpIcon /> : <ChevronDownIcon />}</span>
        </div>
        <div className='content'>
          <Collapse in={more} timeout='auto' unmountOnExit>
            <p>{Dictionary.seats.info.exitRow}</p>
            <p>{Dictionary.seats.info.infants}</p>
          </Collapse>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/seats/seatsInfo/SeatsInfo.js